module.exports = __webpack_public_path__ + "img/review8pp.347ebf52.png";